import { Carousel } from "@scuf/common";
import DatTabAlarms from "./DatTabAlarms";

const Alertas = () => {
  return (
    <>
      <Carousel
        className="carousel-custom carousel-custom-600"
        autoPlay={true}
        transitionTime={10000}
      >
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms
                titleCard="ALERTAS: CHUQUICAMATA"
                division="Chuquicamata"
              />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms
                titleCard="ALERTAS: RADOMIRO TOMIC"
                division="Radomiro Tomic"
              />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms
                titleCard="ALERTAS: MINISTRO HALES"
                division="Ministro Hales"
              />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms
                titleCard="ALERTAS: GABRIELA MISTRAL"
                division="Gabriela Mistral"
              />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms titleCard="ALERTAS: SALVADOR" division="Salvador" />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms titleCard="ALERTAS: ANDINA" division="Andina" />
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <DatTabAlarms
                titleCard="ALERTAS: EL TENIENTE"
                division="El Teniente"
              />
            </div>
          }
        ></Carousel.Slide>
      </Carousel>
    </>
  );
};

export default Alertas;
